import { HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PagedTenantResponse, Tenant, TenantApi, UpdateTenantIpawsAgencyRequest } from 'src/app/hickory-api';
import { mockHandler } from '../mock.handler';

export const buildMockTenant = (id: number, withAgency: boolean): Tenant => {
  const name = `Tenant_${id}`;
  return {
    id,
    name,
    globalId: name + 'globalid',
    brandName: 'Konexues',
    expired: false,
    identityProviderString: null,
    requireSSO: false,
    productEdition: null,
    disabled: false,
    ipawsAgencyId: withAgency ? id : null,
    ipawsAgencyName: withAgency ? `Agency_${id}` : null
  }
}

export const MOCK_TENANTS: Tenant[] = [
  buildMockTenant(1000, true),
  buildMockTenant(1001, false),
  buildMockTenant(1002, true),
];

export class MockTenantApi extends TenantApi {
  private readonly tenants = MOCK_TENANTS;

  override getTenants(ids?: Array<number>, brand?: string, search?: string, state?: string, productEdition?: string, showExpired?: boolean, page?: number, pageSize?: number, withFeatureKeyEnabled?: string, withFeatureKeyDisabled?: string, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<PagedTenantResponse>;
  override getTenants(ids?: Array<number>, brand?: string, search?: string, state?: string, productEdition?: string, showExpired?: boolean, page?: number, pageSize?: number, withFeatureKeyEnabled?: string, withFeatureKeyDisabled?: string, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpResponse<PagedTenantResponse>>;
  override getTenants(ids?: Array<number>, brand?: string, search?: string, state?: string, productEdition?: string, showExpired?: boolean, page?: number, pageSize?: number, withFeatureKeyEnabled?: string, withFeatureKeyDisabled?: string, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<HttpEvent<PagedTenantResponse>>;
  override getTenants(ids?: Array<number>, brand?: string, search?: string, state?: string, productEdition?: string, showExpired?: boolean, page?: number, pageSize?: number, withFeatureKeyEnabled?: string, withFeatureKeyDisabled?: string, observe?: any, reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json'; }): Observable<any> {
    return mockHandler(<PagedTenantResponse>{
      items: this.tenants
    });
  }

  override updateTenantIpawsAgency(tenantId: number, body: UpdateTenantIpawsAgencyRequest, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: undefined; }): Observable<any>;
  override updateTenantIpawsAgency(tenantId: number, body: UpdateTenantIpawsAgencyRequest, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: undefined; }): Observable<HttpResponse<any>>;
  override updateTenantIpawsAgency(tenantId: number, body: UpdateTenantIpawsAgencyRequest, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: undefined; }): Observable<HttpEvent<any>>;
  override updateTenantIpawsAgency(tenantId: number, body: UpdateTenantIpawsAgencyRequest, observe?: any, reportProgress?: boolean, options?: { httpHeaderAccept?: undefined; }): Observable<any> {
    return mockHandler(null);
  }
}
